@if (admin_id == '1') {
  <div class="form-group col-md-6 m-2">
    <label for="menu_name" class="fs-14 fw-500 m-0">Email List (Enter emails with comma seprated)</label>
    <input type="text" class="input_field" [(ngModel)]="emails" />
    <div class="mb-2">
      <span>
        <input type="checkbox" class="secondary-checkbox" name="stop-reminder" id="stop-reminder" [(ngModel)]="stopReminder"/>
        <label for="stop-reminder">Stop Proposal Reminder</label>
      </span>
    </div>
    <div class="mb-2">
      <span>
        <input type="checkbox" class="secondary-checkbox" name="stop-training-reminder" id="stop-training-reminder" [(ngModel)]="stopTrainingReminder"/>
        <label for="stop-training-reminder">Stop Training Reminder</label>
      </span>
    </div>
    <div class="mb-2">
      <span>
        <input type="checkbox" class="secondary-checkbox" name="stop-contract-reminder" id="stop-contract-reminder" [(ngModel)]="stopContractReminder"/>
        <label for="stop-contract-reminder">Stop Contract Reminder</label>
      </span>
    </div>
    <button [disabled]="!emails || (emails && !(emails.trim()).length)" class="btn btn-primary" (click)="setDND()">Submit</button>
  </div>
}

{{success_message}}